import { render } from "./GiftPackAdminPanel.vue?vue&type=template&id=e97d5d74&scoped=true"
import script from "./GiftPackAdminPanel.vue?vue&type=script&lang=js"
export * from "./GiftPackAdminPanel.vue?vue&type=script&lang=js"

import "./GiftPackAdminPanel.vue?vue&type=style&index=0&id=e97d5d74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97d5d74"]])

export default __exports__